export const INSTITUTE_TYPE_NAME_MAX_LENGTH = 50;
export const INSTITUTE_TYPE_CODE_MAX_LENGTH = 50;

export const EIIN_APPLICABLE_LABELS = {
  applicable: 'Yes',
  notApplicable: 'No',
} as const;
